import { Button, HStack, Image, Input, InputGroup, InputRightElement, Text, VStack, useToast, Box, useColorModeValue, Flex, Icon, Heading, Alert, AlertIcon, IconButton } from '@chakra-ui/react';
import React, { useContext, useEffect, useRef, useState } from 'react'
import { AppContext } from '../../../context/AppContext';
import { GetAllCurrency, GetUpi, SubmitTransactionAPI } from '../../../utils/api';
import { useNavigate } from 'react-router-dom';
import { FiCopy, FiCheckCircle, FiArrowLeft } from "react-icons/fi";
import { MdQrCodeScanner } from "react-icons/md";

const UPI = () => {
    const { Token, setBalance } = useContext(AppContext);
    const toast = useToast();
    const [showService, setShowService] = useState("");
    const [usdtPrice, setUsdtPrice] = useState(0)
    const [trxPrice, setTrxPrice] = useState(0);
    const [upiImg, setUpiImg] = useState('');
    const [upiId, setUpiId] = useState('');
    const inputRef = useRef();
    const [hasCopied, setHasCopied] = useState(false);

    // Premium UI Colors
    const cardBg = useColorModeValue("white", "gray.800");
    const borderColor = useColorModeValue("gray.200", "gray.700");
    const textColor = useColorModeValue("gray.800", "white");
    const subTextColor = useColorModeValue("gray.500", "gray.400");
    const inputBg = useColorModeValue("gray.50", "gray.700");

    useEffect(() => {
        GetUpi(Token).then((res) => {
            setUpiImg(res.data.data.imgURL);
            setUpiId(res.data.data.upiId);
        })
        GetAllCurrency(Token).then((res) => {
            res.data.currencies.map((el) => {
                if (el.currencyName == 'USDT') {
                    setUsdtPrice(el.currencyPrice);
                }
                if (el.currencyName == 'TRX') {
                    setTrxPrice(el.currencyPrice);
                }
            })
        }).catch((err) => {
            // setLoading(true);
            console.log(err, 'error saying');
        });
    }, []);

    const CopyToClipBoard = () => {
        navigator.clipboard
            .writeText(upiId)
            .then(() => {
                setHasCopied(true);
                toast({
                    status: "info",
                    title: `Address copied`,
                    isClosable: true,
                    duration: 1000,
                    position: "bottom-right",
                });
                setTimeout(() => setHasCopied(false), 2000);
            })
            .catch((error) => {
                console.error("Failed to copy text: ", error);
                toast({
                    status: "error",
                    title: `errror in copying address`,
                    isClosable: true,
                    duration: 1000,
                });
            });
    };

    const handleTransaction = () => {
        if (inputRef.current.value == "") {
            toast({
                status: "warning",
                title: "Please Enter Transaction Id",
                isClosable: true,
                duration: 1000,
            });
            return;
        }
        SubmitTransactionAPI(Token, { transactionId: inputRef.current.value, method: 'bharatpay' })
            .then((res) => {
                console.log(res.data, "successfull");
                setBalance(res.data.balance);
                toast({
                    title: "Congratulations 🎊",
                    status: "success",
                    description: `Your ${res.data.transaction}rs is successfully added`,
                    isClosable: true,
                    duration: 4000,
                });
                inputRef.current.value = "";
            })
            .catch((err) => {
                toast({
                    status: "error",
                    title: err.response?.data.message,
                    isClosable: true,
                });
                console.log(err, "saying error");
            });
    };

    const navigate = useNavigate();

    return (
        <VStack w="100%" spacing={8} align="center" py={4}>
            <Box
                bg={cardBg}
                border="1px solid"
                borderColor={borderColor}
                rounded="2xl"
                shadow="lg"
                p={{ base: 6, md: 8 }}
                w={{ base: "100%", md: "600px" }}
                maxW="100%"
            >
                <VStack spacing={6}>
                    <VStack spacing={2}>
                        <Flex
                            align="center"
                            justify="center"
                            bg="brand.50"
                            p={3}
                            rounded="full"
                            color="brand.500"
                            mb={2}
                        >
                            <Icon as={MdQrCodeScanner} boxSize={6} />
                        </Flex>
                        <Heading size="md" color={textColor}>Scan QR Code</Heading>
                        <Text color={subTextColor} fontSize="sm" textAlign="center">
                            Scan the QR code below with any UPI app to pay
                        </Text>
                    </VStack>

                    <Box
                        border="2px dashed"
                        borderColor="brand.200"
                        rounded="xl"
                        bg="white"
                    >
                        <Image
                            src={upiImg}
                            alt="UPI QR Code"
                            w="100%"
                            objectFit="contain"
                            fallbackSrc="https://via.placeholder.com/200?text=Loading+QR..."
                        />
                    </Box>

                    <VStack w="100%" spacing={4}>
                        <Box w="100%">
                            <Text mb={2} fontWeight="600" fontSize="sm" color={textColor}>UPI ID</Text>
                            <InputGroup size="lg">
                                <Input
                                    value={upiId}
                                    readOnly
                                    bg={inputBg}
                                    border="1px solid"
                                    borderColor={borderColor}
                                    _focus={{ borderColor: "brand.500" }}
                                    fontSize="md"
                                />
                                <InputRightElement width="4.5rem">
                                    <Button h="1.75rem" size="sm" onClick={CopyToClipBoard} colorScheme={hasCopied ? "green" : "brand"}>
                                        {hasCopied ? <Icon as={FiCheckCircle} /> : <Icon as={FiCopy} />}
                                    </Button>
                                </InputRightElement>
                            </InputGroup>
                        </Box>

                        <Alert status="info" variant="left-accent" rounded="md" fontSize="sm">
                            <AlertIcon />
                            <Box>
                                <Text fontWeight="bold">Important:</Text>
                                After payment, copy the UTR / Reference number and paste it below.
                            </Box>
                        </Alert>

                        <Box w="100%">
                            <Text mb={2} fontWeight="600" fontSize="sm" color={textColor}>UTR / Reference Number</Text>
                            <HStack>
                                <Input
                                    ref={inputRef}
                                    placeholder="Enter UTR ID / Reference number"
                                    size="lg"
                                    bg={inputBg}
                                    border="1px solid"
                                    borderColor={borderColor}
                                    _focus={{ borderColor: "brand.500", boxShadow: "0 0 0 1px var(--chakra-colors-brand-500)" }}
                                />
                                <Button
                                    size="lg"
                                    colorScheme="brand"
                                    px={8}
                                    onClick={handleTransaction}
                                    _hover={{ transform: "translateY(-2px)", shadow: "md" }}
                                    transition="all 0.2s"
                                >
                                    Submit
                                </Button>
                            </HStack>
                        </Box>
                    </VStack>
                </VStack>
            </Box>
        </VStack>
    )
}

export default UPI
